import { render, staticRenderFns } from "./login-after-head-center.vue?vue&type=template&id=5555b1c0&scoped=true&"
import script from "./login-after-head-center.vue?vue&type=script&lang=js&"
export * from "./login-after-head-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5555b1c0",
  null
  
)

export default component.exports